import React from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const BarChartWidget = ({ data }) => {
  const LegendStyle = {
    left: "50%",
    width: "50%",
  };
  return (
    <div className="widget-card">
      <ResponsiveContainer
        className="widget-recharts-responsive-container"
        width={"99%"}
        height={"99%"}
      >
        <BarChart data={data} layout="vertical" label={{ position: "right" }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#dedede" />

          <XAxis type="number" />
          <YAxis dataKey="name" type="category" />
          <Tooltip />
          <Legend
            iconType="circle"
            iconSize={10}
            verticalAlign="top"
            layout="horizontal"
            wrapperStyle={LegendStyle}
          />

          <Bar
            type="monotone"
            dataKey="in"
            nameKey="name"
            fill="#00257B"
            label={{ position: "right" }}
          />

          <Bar
            type="monotone"
            dataKey="out"
            nameKey="name"
            fill="#FF5200"
            label={{ position: "right" }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartWidget;
